import React from 'react';
import UploadsContainer from '../containers/Uploads/UploadsContainer';

const UploadsPage = () => <UploadsContainer />;

export default UploadsPage;
